import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { MicroCycleConfiguration, createMicroCycleConfiguration } from './MicroCycleConfiguration';

export type MesoCycleConfiguration = {
  id: string;
  mesoCycleTemplateId: string;
  mesoCycleConfigurationTemplateId: string;
  type: string;
  workoutsPerCycle: number;
  cycles: number;
  refreshWorkoutInterval: number;
  microCycleConfiguration?: MicroCycleConfiguration;
};

export function createMesoCycleConfiguration(json?: Partial<MesoCycleConfiguration>): MesoCycleConfiguration {
  return makeAutoObservable({
    id: json?.id || UUID(),
    mesoCycleTemplateId: json?.mesoCycleTemplateId || '',
    mesoCycleConfigurationTemplateId: json?.mesoCycleConfigurationTemplateId || '',
    type: json?.type || '',
    workoutsPerCycle: json?.workoutsPerCycle ?? 0,
    cycles: json?.cycles ?? 4,
    refreshWorkoutInterval: json?.refreshWorkoutInterval ?? 0,
    microCycleConfiguration: json?.microCycleConfiguration
      ? createMicroCycleConfiguration(json.microCycleConfiguration)
      : undefined,
  });
}
